export default __webpack_public_path__ + "static/media/PendingCollaboratorStatusIcon.23ae30cc.svg";